import * as yup from 'yup';

const NOTE_MAX_LENGTH = 100;
const DOMAIN_REGEX = /^[^\s]+\.[A-Za-z][^\s]*$/;

export const whitelistDomainSchema = yup.object({
  domain: yup
    .string()
    .required('Domain name is required')
    .matches(DOMAIN_REGEX, 'Enter a valid domain'),
  note: yup
    .string()
    .max(NOTE_MAX_LENGTH, 'Note must be at most 100 characters')
    .optional(),
});
